export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-primary-500 rounded-2xl overflow-hidden">
          <div className="flex flex-col md:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center md:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-3">吃瓜爆料网App下载</h2>
              <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-2">
                支持iOS与Android双平台，推送速度比微博更快，独家内容第一时间送达。
              </p>
              <p className="text-sm md:text-base text-primary-100 leading-relaxed mb-6">
                无需反复查找吃瓜爆料网最新地址，打开App即可直达核心资源。简洁无广告，专注吃瓜体验。
              </p>

              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-apple-fill text-2xl text-foreground-800"></i>
                  <div className="text-left">
                    <div className="text-[10px] text-foreground-400">Download on the</div>
                    <div className="text-sm font-semibold text-foreground-800">App Store</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-google-play-fill text-2xl text-foreground-800"></i>
                  <div className="text-left">
                    <div className="text-[10px] text-foreground-400">GET IT ON</div>
                    <div className="text-sm font-semibold text-foreground-800">Google Play</div>
                  </div>
                </div>
                <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-android-fill text-2xl text-foreground-800"></i>
                  <div className="text-left">
                    <div className="text-[10px] text-foreground-400">直接下载</div>
                    <div className="text-sm font-semibold text-foreground-800">APK安装包</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-3xl bg-background-50/20 backdrop-blur-sm flex items-center justify-center border border-background-50/30">
                <i className="ri-smartphone-line text-6xl md:text-7xl text-background-50"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}